<template>
  <div class="d-flex">
    <date-field
      :type="type"
      :label="label"
      :field="field"
      :placeholder="settings.placeholder"
      :help="settings.help_text"
    ></date-field>
    <fb-field-config :field="field"></fb-field-config>
  </div>
</template>

<script>
import { getSettings } from "../../assets/js/common.helper";
import DateField from "../ui/form/DateField.vue";
import FbFieldConfig from "./FbFieldConfig.vue";
export default {
  props: { field: {} },
  components: { FbFieldConfig, DateField },
  computed: {
    label() {
      return this.field.Form_Label;
    },
    type() {
      return this.field.Field_Type;
    },

    settings() {
      return getSettings({ ...this.field });
    },
  },
};
</script>

<style>
</style>